// extracted by mini-css-extract-plugin
export default {"checkout_summary":"Pq","checkout_summary_wrapper":"Qq","summary_items":"Rq","line_items_wrapper":"Sq","separator":"Tq","order_summary":"Uq","line_item":"Vq","order__summary_item_title":"Wq","recurringdis":"Xq","note":"Yq","carbon_emission":"Zq","unlock_savings":"ar","member_perk":"br","info":"cr","no_items":"er","promo":"fr","order_summary_mobile":"gr","open_summary_mobile":"hr","fixed_bottom_info":"ir","open_info":"jr","text":"kr","open_summary":"lr"};
    if(module.hot) {
      // 1713969925835
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  